import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleGridSection() {
  return (
    <section id="seo-articles" className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold uppercase tracking-wider mb-4">
            Learning Center
          </span>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            Itaobuy Spreadsheet Guides &amp; Resources
          </h2>
          <p className="mt-4 text-foreground-600 text-base md:text-lg max-w-xl mx-auto">
            In-depth articles, tutorials, and strategies to help you master the itaobuy spreadsheet system and optimize your purchasing workflow.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group flex flex-col rounded-xl bg-background-50 border border-background-200 hover:border-primary-200 transition-all duration-300 overflow-hidden"
            >
              <div className="w-full h-44 md:h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.imageAlt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6 flex flex-col flex-1">
                <span className="text-xs text-foreground-500 mb-2">{article.date}</span>
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 group-hover:text-primary-700 transition-colors duration-200 line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-3 flex-1">
                  {article.excerpt}
                </p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 group-hover:text-primary-700 transition-colors duration-200 whitespace-nowrap">
                  Read Article
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Explore the Full Platform
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}